
import Main from '../components/Main';


import {connect} from 'react-redux';

import { openDrawer, closeDrawer } from '../actions'


const mapStateToProps = (state, props) => {
    return {
        drawer: state.drawer
    };
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        closeDrawer: (content) => dispatch(closeDrawer(content)),
        openDrawer: (content) => dispatch(openDrawer(content))
    }
}

const ConnectedMain = connect(mapStateToProps, mapDispatchToProps)(Main)

export default ConnectedMain;


// WEBPACK FOOTER //
// ./src/containers/ConnectedMain.jsx